
import React from 'react'
import PropTypes from 'prop-types'
import Bullet from '../Bullet/Bullet'
import styles from './IconBulletList.module.scss'

const IconBulletList = (props) => {
  const { items, title, icon } = props

  return (
    <div className={styles.iconBulletList}>
      { title && <h4 className={styles.title}>{title}</h4> }
      <ul>
        { items.map((text, i) => {
          const className = i !== items.length - 1 ? styles.marginBottom : null

          return (
            <Bullet
              // eslint-disable-next-line react/no-array-index-key
              key={`iconBullet_${i}`}
              icon={icon}
              text={text}
              className={className} />
          )
        }) }
      </ul>
    </div>
  )
}

IconBulletList.defaultProps = {
  title: '',
  icon: '',
}

IconBulletList.propTypes = {
  title: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.string).isRequired,
  icon: PropTypes.string,
}

export default IconBulletList



// WEBPACK FOOTER //
// ./src/components/Onboarding/Shared/IconBulletList/IconBulletList.jsx